import { completeTypes, createTypes, withPostSuccess } from 'redux-recompose';

import * as AdelphiCasksService from '#services/AdelphiCaskFillingsService';
import ModalActions from '#redux/Modal/actions';
import { MODALS } from '#redux/Modal/constants';

import { ADELPHI_CASKS_TARGETS } from './constants';

export const actions = createTypes(
  completeTypes({
    primaryActions: ['GET_ALL_CASK_FILLINGS', 'CREATE_ADELPHI_CASKS_OF_EXCEL', 'GET_CASK_FILLING_BY_ID'],
    ignoredActions: ['SET_CURRENT_ADELPHI_CASK_FILLING']
  }),
  '@@ADELPHI_CASK_FILLINGS'
);

export const actionCreators = {
  getAllCaskFillings: () => ({
    type: actions.GET_ALL_CASK_FILLINGS,
    target: ADELPHI_CASKS_TARGETS.ADELPHI_CASK_FILLINGS,
    service: AdelphiCasksService.getAllAdelphiCaskFillings
  }),
  getCaskFillingById: ({ id }) => ({
    type: actions.GET_CASK_FILLING_BY_ID,
    target: ADELPHI_CASKS_TARGETS.ADELPHI_CASK_FILLING_BY_ID,
    service: AdelphiCasksService.getAdelphiCaskFillingById,
    payload: { id },
    successSelector: response => response.data.caskFilling
  }),
  createAdelphiCasksOfExcel: ({ s3Url, fillId, periodId }) => ({
    type: actions.CREATE_ADELPHI_CASKS_OF_EXCEL,
    target: ADELPHI_CASKS_TARGETS.CREATE_ADELPHI_CASKS_OF_EXCEL,
    service: AdelphiCasksService.createAdelphiCasksOfExcel,
    payload: { s3Url, fillId, periodId },
    injections: [
      withPostSuccess(dispatch => {
        dispatch(actionCreators.getAllCasksAndCloseModal(MODALS.ADELPHI_CASK_FILLING));
      })
    ]
  }),
  getAllCasksAndCloseModal: modal => dispatch => {
    dispatch(actionCreators.getAllCaskFillings());
    dispatch(ModalActions.closeModal(modal));
  },
  setCurrentCaskFilling: payload => ({
    type: actions.SET_CURRENT_ADELPHI_CASK_FILLING,
    target: ADELPHI_CASKS_TARGETS.CURRENT_ADELPHI_CASK_FILLING,
    payload
  }),
  deleteCaskFillingById: ({ id }) => ({
    type: actions.DELETE_CASK_FILLING_BY_ID,
    target: ADELPHI_CASKS_TARGETS.ADELPHI_CASK_FILLING_BY_ID,
    service: AdelphiCasksService.deleteAdelphiCaskFillingById,
    payload: { id },
    injections: [
      withPostSuccess(dispatch => {
        dispatch(actionCreators.getAllCasksAndCloseModal(MODALS.DELETE_RECORD));
        dispatch(actionCreators.setCurrentCaskFilling(null));
      })
    ]
  })
};

export default actionCreators;
